export default __webpack_public_path__ + "static/media/adopt.7ddf6f46.png";